<template>
  <div class='shop-subscribe-container'>
    <div class="qrcode-img-wrapper">
      <img src="../../assets/img/img_qrcode_1.png">
      <p>长按二维码关注【国花瓷消费者服务】服务号</p>
      <p>关注后再次扫码</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopSubscribe',
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-subscribe-container {
  width: 100%;
  height: 100%;
  background: #fff;
  .qrcode-img-wrapper {
    padding: 150px 0;
    text-align: center;
    img {
      width: 186px;
      height: 186px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #747474;
      letter-spacing: -0.35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/shop/subscribe.vue